const formatPrice = (price) => {
    if (typeof price === 'number') {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        });
        return formatter.format(price);
    }
}

export { formatPrice }